export enum AccountTab {
    Profile = 'profile',
    Subscription = 'subscription',
    Settings = 'settings',
    PlanSettings = 'plan-settings',
}
